import { Route, Routes } from 'react-router-dom';
import { Overview } from './overview';
import { WarrantProgramsRoutes } from './warrants/WarrantPrograms';
import { QesoProgramsRoutes } from './employee-options/QesoPrograms';

export const StockOptions = () => {
  return (
    <Routes>
      <Route path="overview" element={<Overview />} />
      <Route path="warrant-programs" element={<WarrantProgramsRoutes />}>
        <Route path="*" element={<WarrantProgramsRoutes />} />
      </Route>
      <Route path="employee-options" element={<QesoProgramsRoutes />}>
        <Route path="*" element={<QesoProgramsRoutes />} />
      </Route>
    </Routes>
  );
};
